var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('a-modal', {
    attrs: {
      "title": "报名信息",
      "width": 600,
      "dialog-style": {
        top: '20px'
      },
      "maskClosable": false,
      "keyboard": false,
      "visible": _vm.visible,
      "confirm-loading": _vm.confirmLoading,
      "footer": null
    },
    on: {
      "ok": _vm.handleOk,
      "cancel": _vm.handleCancel
    }
  }, [_c('a-form', {
    attrs: {
      "form": _vm.form,
      "label-col": _vm._isMobile() ? {} : {
        span: 8
      },
      "wrapper-col": _vm._isMobile() ? {} : {
        span: 12
      },
      "layout": _vm._isMobile() ? 'vertical' : 'horizontal'
    }
  }, [_c('a-form-item', {
    attrs: {
      "label": "选择项目"
    }
  }, [_c('j-category-select', {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: ['eventCategory', _vm.validatorRules.eventCategory],
      expression: "['eventCategory', validatorRules.eventCategory]"
    }],
    attrs: {
      "disabled": _vm.applyConfig.canEditCatagory != 1,
      "mutex": true,
      "dropdownStyle": {
        maxHeight: '300px',
        overflow: 'auto'
      },
      "pid": _vm.eventInfo.eventCategory,
      "onlyLeaf": true,
      "getPopupContainer": function getPopupContainer(triggerNode) {
        return triggerNode.parentNode;
      },
      "multiple": _vm.canApplyMulti && _vm.eventInfo.applyMulti == 1,
      "treeCheckable": _vm.canApplyMulti && _vm.eventInfo.applyMulti == 1,
      "placeholder": "请选择项目"
    },
    on: {
      "change": _vm.onEventCategoryChange
    }
  })], 1), _vm.model.eventCategory ? _c('a-form-item', {
    attrs: {
      "label": "赛项确认"
    }
  }, [_c('span', [_vm._v("您选择了"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.model.eventCategory.split(',').length))]), _vm._v("个赛项，报名费用"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.applyPrice))]), _vm._v("元。")])]) : _vm._e(), _vm.applyConfig.photo > 0 ? _c('a-form-item', {
    attrs: {
      "label": "证件照"
    }
  }, [_c('div', {
    staticClass: "ant-upload-preview",
    on: {
      "click": function click($event) {
        return _vm.$refs.photoModal.edit(1);
      }
    }
  }, [_c('a-icon', {
    staticClass: "upload-icon",
    attrs: {
      "type": "cloud-upload-o"
    }
  }), _c('div', {
    staticClass: "mask"
  }, [_c('a-icon', {
    attrs: {
      "type": "plus"
    }
  })], 1), _vm.applyEventInfo.photo_url ? _c('img', {
    attrs: {
      "src": _vm.applyEventInfo.photo_url
    }
  }) : _vm._e()], 1), _c('a-divider'), _c('p', {
    staticStyle: {
      "line-height": "1.3em",
      "color": "red"
    }
  }, [_vm._v("请核对照片是否为1寸蓝底免冠照片，不符合要求请重新提交，照片直接印制在证书上，请谨慎核验提交")])], 1) : _vm._e(), _c('a-form-item', {
    attrs: {
      "label": "姓名"
    }
  }, [_c('a-input', {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: ['realname'],
      expression: "['realname']"
    }],
    attrs: {
      "disabled": ""
    }
  })], 1), _c('a-form-item', {
    attrs: {
      "label": "身份证号码"
    }
  }, [_c('a-input', {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: ['idcard'],
      expression: "['idcard']"
    }],
    attrs: {
      "disabled": "",
      "placeholder": "身份证/护照/台胞证"
    }
  })], 1), _c('a-form-item', {
    attrs: {
      "label": "辅导老师"
    }
  }, [_c('a-input', {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: ['teacherName', _vm.validatorRules.teacherName],
      expression: "['teacherName', validatorRules.teacherName]"
    }]
  })], 1), _c('a-form-item', {
    attrs: {
      "label": "老师电话"
    }
  }, [_c('a-input', {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: ['teacherPhone', _vm.validatorRules.teacherPhone],
      expression: "['teacherPhone', validatorRules.teacherPhone]"
    }]
  })], 1), _c('a-form-item', {
    attrs: {
      "label": "学校/机构"
    }
  }, [_vm.checkNumber(_vm.applyEventInfo.school) ? _c('j-search-select-tag', {
    attrs: {
      "placeholder": "请选择学校/机构",
      "async": true,
      "disabled": "",
      "dict": "teaching_agent,agent_name,id"
    },
    model: {
      value: _vm.applyEventInfo.school,
      callback: function callback($$v) {
        _vm.$set(_vm.applyEventInfo, "school", $$v);
      },
      expression: "applyEventInfo.school"
    }
  }) : _c('a-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: _vm.applyEventInfo.school,
      callback: function callback($$v) {
        _vm.$set(_vm.applyEventInfo, "school", $$v);
      },
      expression: "applyEventInfo.school"
    }
  })], 1), _c('a-form-item', {
    attrs: {
      "label": "所在地区"
    }
  }, [_c('j-area-linkage', {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: ['address', _vm.validatorRules.address],
      expression: "['address', validatorRules.address]"
    }],
    attrs: {
      "type": "cascader",
      "placeholder": "请输入省市区"
    }
  })], 1), _vm.eventInfo.applyTeam == 1 ? _c('a-collapse', {
    attrs: {
      "defaultActiveKey": "1"
    }
  }, [_c('a-collapse-panel', {
    key: "1",
    attrs: {
      "header": "队友信息 (如单人项目，不填)",
      "forceRender": ""
    }
  }, [_c('a-form-item', {
    attrs: {
      "label": "队友姓名"
    }
  }, [_c('a-input', {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: ['teammateNames'],
      expression: "['teammateNames']"
    }],
    attrs: {
      "placeholder": ""
    }
  })], 1), _c('a-form-item', {
    attrs: {
      "label": "身份证号码"
    }
  }, [_c('a-input', {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: ['teammateIdcards'],
      expression: "['teammateIdcards']"
    }],
    attrs: {
      "placeholder": ""
    }
  })], 1), _c('a-form-item', {
    attrs: {
      "label": "年级"
    }
  }, [_c('j-dict-select-tag', {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: ['teammateGrades'],
      expression: "['teammateGrades']"
    }],
    attrs: {
      "trigger-change": true,
      "dictCode": "grade",
      "placeholder": "请选择年级"
    }
  })], 1)], 1)], 1) : _vm._e(), _c('a-button', {
    staticStyle: {
      "display": "block",
      "margin": "20px auto",
      "width": "200px"
    },
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.confirmLoading
    },
    on: {
      "click": _vm.handleOk
    }
  }, [_vm._v(_vm._s(_vm.eventCategory ? '修改' : '报名'))])], 1), _c('EventPay', {
    ref: "eventPay",
    on: {
      "payOk": _vm.payOk
    }
  }), _c('PhotoModal', {
    ref: "photoModal",
    on: {
      "ok": _vm.photoChange
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };